// src/lib/legal/partnerFinancialConsent.js

import { supabase } from "../../supabaseClient";

function createRpcError(
  error,
  fallbackMessage
) {
  const nextError = new Error(
    error?.message ||
      fallbackMessage
  );

  nextError.code =
    error?.code || "";

  nextError.details =
    error?.details || "";

  nextError.hint =
    error?.hint || "";

  return nextError;
}

export async function getMyPartnerFinancialSharingConsents() {
  const {
    data,
    error,
  } = await supabase.rpc(
    "get_my_partner_financial_sharing_consents"
  );

  if (error) {
    throw createRpcError(
      error,
      "Your partner sharing choices could not be loaded."
    );
  }

  return Array.isArray(data)
    ? data
    : [];
}

export async function setMyPartnerFinancialSharingConsent({
  consentId,
  enabled,
}) {
  if (!consentId) {
    throw new Error(
      "A consent record is required."
    );
  }

  const {
    data,
    error,
  } = await supabase.rpc(
    "set_my_partner_financial_sharing_consent",
    {
      p_consent_id: consentId,
      p_enabled: enabled === true,
    }
  );

  if (error) {
    throw createRpcError(
      error,
      "Your financial sharing choice could not be saved."
    );
  }

  const rows =
    Array.isArray(data)
      ? data
      : data
      ? [data]
      : [];

  return rows[0] || null;
}